<template>
  <div
    class="flex items-center p-2 color-palette-select-item"
    :class="{'active': isActive}"
    @click="$emit('selectcolorPalette', colorPalette)"
  >
    <div class="flex gap-2">
      <div class="flex gap-1">
        <div
          v-for="color in colors"
          :key="color"
          :style="{'background-color': color}"
          class="w-4 h-4 bg-red-400 rounded-full"
        />
      </div>
      <div>{{ colorPalette?.title }}</div>
    </div>
  </div>
</template>

<script>
import { take } from 'lodash'

export default {
  name: 'ColorPaletteSelectItem',
  props: {
    colorPalette: {
      type: Object,
      default: () => {},
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colors() {
      if (!this.colorPalette?.colors) return []
      return take(this.colorPalette?.colors, 5)
    },
  },
}
</script>

<style lang="scss" scoped>
.color-palette-select-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    @apply bg-primary-50;
    background-color: #F0F4FA;
  }
}
</style>
